import github from "../assets/images/icons/github.png";
import linkedin from "../assets/images/icons/linkedin.png";
import phone from "../assets/images/icons/phone.png";
import envelope from "../assets/images/icons/envelope.png";

export default [
  {
    icon: envelope,
    destination: "mailto:toreskey@gmail.com",
    name: "Email",
  },
  {
    icon: phone,
    destination: "tel:+15636394736",
    name: "Phone",
  },
  {
    icon: github,
    destination: "https://github.com/Tyler-Oreskey",
    name: "GitHub",
  },
  {
    icon: linkedin,
    destination: "https://www.linkedin.com/in/tyler-oreskey/",
    name: "LinkedIn",
  },
];
